<dx-toolbar #toolbar class="report-toolbar">
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row mr-4 items-center">
        <span class="block mr-2 text-sm font-medium">Date: </span>
        <dx-select-box
          stylingMode="underlined"
          width="140"
          displayExpr="label"
          valueExpr="value"
          placeholder="Filter"
          [value]="currentFilter"
          (onValueChanged)="dateFilterChanged($event)"
          [items]="dateFilters">
        </dx-select-box>
      </div>
    </div>
  </dxi-item>
  <dxi-item location="before"
            widget="dxButton"
            [visible]="currentFilter == 0"
            locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row mr-4 items-center">
        <span class="block mr-2 text-sm font-medium">Date début: </span>
        <dx-date-box
          stylingMode="underlined"
          (onValueChanged)="dateChanged($event)"
          [(value)]="request.from">
        </dx-date-box>
      </div>
    </div>
  </dxi-item>
  <dxi-item location="before"
            [visible]="currentFilter == 0"
            widget="dxButton"
            locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row mr-4 items-center">
        <span class="block mr-2 text-sm font-medium">Date fin: </span>
        <dx-date-box
          stylingMode="underlined"
          (onValueChanged)="dateChanged($event)"
          [(min)]="request.from"
          [(value)]="request.to">
        </dx-date-box>
      </div>
    </div>
  </dxi-item>
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row mr-4 items-center">
        <span class="block mr-2 text-sm font-medium">Tracteur: </span>
        <dx-select-box
          stylingMode="underlined"
          width="140"
          displayExpr="name"
          placeholder="Tracteur"
          searchMode="contains"
          [searchExpr]="['name', 'id']"
          [searchEnabled]="true"
          [(value)]="request.field"
          [items]="fields">
        </dx-select-box>
      </div>
    </div>
  </dxi-item>
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="never">
    <div *dxTemplate>
      <div class="flex flex-row mr-4 items-center">
        <span class="block mr-2 text-sm font-medium">Opération: </span>
        <dx-drop-down-box
          class="operation-types-selector"
          stylingMode="underlined"
          displayExpr="name"
          placeholder="Tous"
          [dropDownOptions]="{elementAttr: {class: 'operation-types-selector-popup'}, width: 250}"
          [value]="request.trailerOperationType"
          [(opened)]="isDropDownBoxOpened"
          [dataSource]="operationTypes">
          <dx-list
            [dataSource]="operationTypes"
            [showSelectionControls]="true"
            displayExpr="name"
            selectionMode="all"
            searchMode="contains"
            [searchExpr]="['name', 'id']"
            [searchEnabled]="true"
            (onSelectionChanged)="changeDropDownBoxValue($event)">
            <dxo-search-editor-options stylingMode="underlined"></dxo-search-editor-options>
          </dx-list>
        </dx-drop-down-box>
        <!--<dx-select-box
          stylingMode="underlined"
          displayExpr="name"
          placeholder="Tous"
          searchMode="contains"
          [showClearButton]="true"
          [searchExpr]="['name', 'id']"
          [searchEnabled]="true"
          [(value)]="request.trailerOperationType"
          [items]="operationTypes">
        </dx-select-box>-->
      </div>
    </div>
  </dxi-item>
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="auto"
            [options]="generateButtonOptions">
  </dxi-item>

  <dxi-item location="after"
            widget="dxButton"
            locateInMenu="auto"
            [options]="exportButtonOptions">
  </dxi-item>
</dx-toolbar>

<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.1)"
  [position]="{ of: '.report-toolbar' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
